/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import { Radio, RadioGroup, Text, VStack } from '@mybridge/ui';
import { useMutation } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import React from 'react';
import API from 'v4/store/common/api';
import { APIEndPoints } from 'v4/store/common/endPoint';
import { Box, HStack } from '@mybridge/ui';
import { StackDivider } from '@chakra-ui/react';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const TagSection = ({ whoCanSee }) => {
  const [state, setState] = React.useState(whoCanSee?.who_can_see || 'anyone');
  const { t } = useTranslator();
  const { mutate } = useMutation({
    mutationFn: async (body) => {
      return await API({
        method: 'POST',
        url: `${APIEndPoints.Notification}/email/`,
        body: JSON.stringify(body),
      });
    },
    onSuccess: (data) => {
      setState(data.who_can_see);
    },
  });

  const handleChange = (value) => {
    setState(value);
    mutate({ _for: 'tag', enabled: true, who_can_see: value });
  };

  return (
    <AuthenticatedProviders>
      <RadioGroup onChange={handleChange} value={state}>
        <VStack
           divider={!isMobile ? <StackDivider borderColor="gray.200" /> : null}
          spacing={3}
          align="stretch"
          mt={3}
        >
          <HStack w="100%" justifyContent="space-between" my={2}>
            <Text color="brandGray.850">{t('settingNotification.anyone') || "Anyone"}</Text>
            <Box>
              <Radio
                // isSelected={state === 'anyone'}
                // onClick={() => {
                //   mutate({ _for: 'tag', enabled: true, who_can_see: 'anyone' });
                // }}
                // changed={() => {
                //   setState('anyone');
                // }}
                value="anyone"
                name="tagEmail"
              />
            </Box>
          </HStack>
          <HStack w="100%" justifyContent="space-between" my={2}>
            <Text color="brandGray.850">{t('settingNotification.friends') || "Friends"}</Text>
            <Box>
              <Radio
                // isSelected={state === 'friends'}
                // onClick={() => {
                //   mutate({ _for: 'tag', enabled: true, who_can_see: 'friends' });
                // }}
                // changed={() => {
                //   setState('friends');
                // }}
                value="friends"
                name="tagEmail"
              />
            </Box>
          </HStack>
          <HStack w="100%" justifyContent="space-between" my={2}>
            <Text color="brandGray.850">{t('settingNotification.friendsOfFriends') || "Friends of Friends"}</Text>
            <Box>
              <Radio
                // isSelected={state === 'friends_of_friends'}
                // onClick={() => {
                //   mutate({
                //     _for: 'tag',
                //     enabled: true,
                //     who_can_see: 'friends_of_friends',
                //   });
                // }}
                // changed={() => {
                //   setState('friends_of_friends');
                // }}
                value="friends_of_friends"
                name="tagEmail"
              />
            </Box>
          </HStack>
        </VStack>
      </RadioGroup>
    </AuthenticatedProviders>
  );
};

TagSection.propTypes = {
  whoCanSee: PropTypes.string,
};

TagSection.defaultProps = {
  whoCanSee: 'anyone',
};

export default TagSection;
